import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './en';
import { id } from './id';

export const LANGS = ['id', 'en'] as const;
export type Lang = (typeof LANGS)[number];
/** ⚠️ Kunci yang SAMA dengan `pos-web`: satu perangkat, satu pilihan bahasa. */
const LS_KEY = 'osbpos.lang';

export function currentLang(): Lang {
  const s = typeof localStorage === 'undefined' ? null : localStorage.getItem(LS_KEY);
  return s === 'en' || s === 'id' ? s : 'id';
}

void i18n.use(initReactI18next).init({
  resources: { id: { translation: id }, en: { translation: en } },
  lng: currentLang(),
  fallbackLng: 'id',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLang(lng: Lang): void {
  localStorage.setItem(LS_KEY, lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
